// Navigation interne des écrans de l'urbanisme (lot L5-C2, M18) : demandes et carte, configuration.
import { Lien } from '@cc/ui';
import styles from '../achats/achats.module.css';

const ENTREES = [
  { id: 'demandes', libelle: 'Demandes et carte', href: '/urbanisme' },
  { id: 'configuration', libelle: 'Zones, plans et types de demandes', href: '/urbanisme/configuration' },
] as const;

export function NavigationUrbanisme({ actif }: { actif: (typeof ENTREES)[number]['id'] }) {
  return (
    <nav className={styles.navigation} aria-label="Urbanisme">
      {ENTREES.map((e) => (
        <Lien key={e.id} href={e.href} aria-current={e.id === actif ? 'page' : undefined} className={e.id === actif ? styles.lienActif : styles.lien}>
          {e.libelle}
        </Lien>
      ))}
    </nav>
  );
}
